import React from 'react';
import './Shipping.css';

const Shipping = () => {
  return (
    <div className="shipping-page">
      <div className="container">
        <div className="shipping-header">
          <h1>Shipping & Service Delivery Policy</h1>
          <p className="last-updated">Last Updated: December 10, 2024</p>
        </div>

        <div className="shipping-content">
          <section className="shipping-section">
            <div className="section-number">1</div>
            <div className="section-content">
              <h2>Service Delivery Overview</h2>
              <p>
                SyarTech is a mobile car washing service that delivers professional car care directly to your location. All services are performed at the customer’s chosen address within our supported service areas across Egypt.
              </p>
            </div>
          </section>

          <section className="shipping-section">
            <div className="section-number">2</div>
            <div className="section-content">
              <h2>Service Coverage Areas</h2>
              <ul>
                <li>6th of October City</li>
                <li>Additional areas will be added gradually</li>
              </ul>
              <p>
                Please check the app for the latest coverage and availability.
              </p>
            </div>
          </section>

          <section className="shipping-section">
            <div className="section-number">3</div>
            <div className="section-content">
              <h2>Service Appointment Scheduling</h2>
              <p>
                Service timing is agreed upon at the time of booking or subscription creation. Appointments are scheduled based on availability and service route planning.
              </p>
              <ul>
                <li>One-time bookings are scheduled based on availability</li>
                <li>Subscription services follow pre-agreed schedules</li>
                <li>Recurring services are delivered according to the selected plan</li>
              </ul>
            </div>
          </section>

          <section className="shipping-section">
            <div className="section-number">4</div>
            <div className="section-content">
              <h2>Service Time Ranges</h2>
              <p>
                Instead of fixed appointment times, services are delivered within the following general time ranges:
              </p>
              <ul>
                <li><strong>Morning Service:</strong> Delivered during morning hours</li>
                <li><strong>Midday Service:</strong> Delivered during daytime hours</li>
                <li><strong>Evening Service:</strong> Delivered during evening hours</li>
              </ul>
              <p>
                Customers will receive notifications when the technician is on the way.
              </p>
            </div>
          </section>

          <section className="shipping-section">
            <div className="section-number">5</div>
            <div className="section-content">
              <h2>Service Duration</h2>
              <p>
                Service duration varies depending on vehicle size, selected package, and condition of the vehicle. Estimated durations are provided in the app for reference purposes only.
              </p>
            </div>
          </section>

          <section className="shipping-section">
            <div className="section-number">6</div>
            <div className="section-content">
              <h2>Location Requirements</h2>
              <ul>
                <li>Safe and legal parking location</li>
                <li>Sufficient space around the vehicle</li>
                <li>Clear access for service vehicles</li>
                <li>Required permissions for mobile services if applicable</li>
              </ul>
            </div>
          </section>

          <section className="shipping-section">
            <div className="section-number">7</div>
            <div className="section-content">
              <h2>Rescheduling and Delays</h2>
              <p>
                Customers may request rescheduling through the app. While SyarTech does not charge rescheduling fees, repeated last-minute changes may affect future booking availability.
              </p>
              <p>
                In case of delays on our side, customers will receive updates and alternative arrangements such as rescheduling or refunds if service cannot be completed.
              </p>
            </div>
          </section>

          <section className="shipping-section">
            <div className="section-number">8</div>
            <div className="section-content">
              <h2>Weather-Related Adjustments</h2>
              <ul>
                <li>Severe weather may require rescheduling</li>
                <li>Customers will be notified through the app</li>
                <li>No penalties apply for weather-related changes</li>
                <li>Refunds or priority rescheduling available if needed</li>
              </ul>
            </div>
          </section>

          <section className="shipping-section">
            <div className="section-number">9</div>
            <div className="section-content">
              <h2>Product Delivery (Add-ons)</h2>
              <ul>
                <li>Products ordered with services are delivered during the appointment</li>
                <li>Standalone product orders are shipped separately</li>
                <li>Delivery fees and availability are shown in the app</li>
              </ul>
            </div>
          </section>

          <section className="shipping-section">
            <div className="section-number">10</div>
            <div className="section-content">
              <h2>Corporate & Fleet Services</h2>
              <ul>
                <li>On-site services for businesses</li>
                <li>Flexible scheduling for multiple vehicles</li>
                <li>Customized service plans</li>
                <li>Dedicated account coordination</li>
              </ul>
            </div>
          </section>

          <section className="shipping-section">
            <div className="section-number">11</div>
            <div className="section-content">
              <h2>Service Tracking</h2>
              <ul>
                <li>Live service status updates via the app</li>
                <li>Push notifications for arrival and completion</li>
                <li>Direct communication with assigned technician</li>
              </ul>
            </div>
          </section>

          <section className="shipping-section">
            <div className="section-number">12</div>
            <div className="section-content">
              <h2>Contact for Service Delivery</h2>
              <ul>
                <li>In-app customer support</li>
                <li>
                  Website: <a href="https://kamshka.com/contact" target="_blank" rel="noopener noreferrer">
                    kamshka.com/contact
                  </a>
                </li>
                <li>Facebook & Instagram support channels</li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Shipping;
